import { Card, Box, Typography, CardContent } from "@mui/material/";
import InnerHeader from "../Layout/InnerHeader";
import { useParams } from "react-router-dom";
import { Messages } from "../../_helpers/Constant";

export default function License() {
  const { info } = useParams();
  const data = Messages.find((e) => e.ExpiryType === info);

  return (
    <Box width="100%">
      <InnerHeader name={"Upgrade License"} />
      <Card className="genKeyMain">
        <CardContent>
          <Box>
            <Typography variant="h6">{data?.Header}</Typography>
            <Typography className="code">{data?.Message}</Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
